import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Pencil, Check, X } from "lucide-react";
import { toast } from "sonner";

// Montant d'une cotisation, modifiable sur place par un admin. Le solde du
// de l'adherent est recalcule par le serveur a chaque changement.
export default function MontantCotisation({ cotisation, onDone, readOnly }) {
  const [edit, setEdit] = useState(false);
  const [valeur, setValeur] = useState(String(cotisation.montant ?? ""));
  const [envoi, setEnvoi] = useState(false);

  const afficher = cotisation.montant === 0 ? "Offert" : cotisation.montant + " \u20AC";
  if (readOnly) return <span className="font-semibold">{afficher}</span>;

  const enregistrer = async () => {
    const m = parseFloat(valeur);
    if (isNaN(m) || m < 0) { toast.error("Montant invalide"); return; }
    setEnvoi(true);
    try {
      const token = localStorage.getItem("token");
      const url = process.env.REACT_APP_BACKEND_URL + "/api/cotisations/" + cotisation.id;
      const r = await fetch(url, {
        method: "PUT",
        headers: { "Authorization": "Bearer " + token, "Content-Type": "application/json" },
        body: JSON.stringify({ montant: m })
      });
      const res = await r.json();
      if (!r.ok) throw new Error(res.detail || "Erreur");
      toast.success("Montant : " + m + " \u20AC, solde du : " + res.solde_du + " \u20AC");
      setEdit(false);
      if (onDone) onDone();
    } catch (e) {
      toast.error(e.message || "Modification impossible");
    }
    setEnvoi(false);
  };

  if (!edit) {
    return (
      <span className="inline-flex items-center gap-1 font-semibold">
        {afficher}
        <Button variant="ghost" size="icon" className="h-6 w-6 opacity-50 hover:opacity-100"
          onClick={() => { setValeur(String(cotisation.montant ?? "")); setEdit(true); }}
          title="Modifier le montant">
          <Pencil className="w-3 h-3" />
        </Button>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1">
      <Input type="number" step="0.01" min="0" value={valeur} autoFocus
        className="h-7 w-24 text-right"
        onChange={(e) => setValeur(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") enregistrer();
          if (e.key === "Escape") setEdit(false);
        }} />
      <Button variant="ghost" size="icon" className="h-6 w-6 text-green-600"
        onClick={enregistrer} disabled={envoi}>
        <Check className="w-3.5 h-3.5" />
      </Button>
      <Button variant="ghost" size="icon" className="h-6 w-6 text-muted-foreground"
        onClick={() => setEdit(false)}>
        <X className="w-3.5 h-3.5" />
      </Button>
    </span>
  );
}
